export default {"src":"/_next/static/media/success-alert.138a34c9.svg","height":27,"width":27};